import { NgModule } from '@angular/core';
import { combineReducers, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  insulationReducers,
  insulationSelectorKey,
} from './store/insulation-form.state';
import { InsulationFunnelEffects } from './store/insulation-funnel/insulation-funnel.effects';
import { InsulationWizardEffects } from './store/insulation-wizard/insulation-wizard.effects';
import { InsulationOrderFormEffects } from './store/insulation-order-form/insulation-order-form.effects';
import { InsulationProductOverviewEffects } from './store/insulation-products/insulation-product-overview.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(
      insulationSelectorKey,
      combineReducers(insulationReducers)
    ),
    EffectsModule.forFeature([
      InsulationFunnelEffects,
      InsulationWizardEffects,
      InsulationOrderFormEffects,
      InsulationProductOverviewEffects,
    ]),
  ],
})
export class InsulationBootstrapModule {}
